// components/Projects.js
import React from 'react';
import SectionTitle from './SectionTitle';
import Image from '../images/solar-energy.webp';
const ProjectCard = ({ image, title, category, description }) => {
  return (
    <div className="bg-white rounded-lg overflow-hidden shadow-md">
      <img 
        src={image} 
        alt={title} 
        className="w-full h-48 object-cover"
      />
      <div className="p-6">
        <span className="inline-block px-3 py-1 text-sm text-white bg-primary rounded-full mb-2">
          {category}
        </span>
        <h3 className="text-xl font-semibold mb-2">{title}</h3>
        <p className="text-gray-600">{description}</p>
      </div>
    </div>
  );
};

const Projects = () => {
  const projects = [
    {
      id: 1,
      image: Image,
      title: "Residential Off-Grid System",
      category: "Residential",
      description: "10kW off-grid system with battery storage for a family home in rural area."
    },
    {
      id: 2,
      image: Image,
      title: "Commercial Rooftop Installation",
      category: "Commercial",
      description: "50kW grid-tied solar PV system for a manufacturing facility, reducing energy costs by 40%."
    },
    {
      id: 3,
      image: Image,
      title: "Hybrid Solar System",
      category: "Residential",
      description: "15kW hybrid system with 20kWh battery backup for uninterrupted power supply."
    }
  ];

  return (
    <section id="projects" className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <SectionTitle 
          title="Recent Projects" 
          subtitle="See our work in action"
          centered={true}
        />
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project) => (
            <ProjectCard 
              key={project.id}
              image={project.image}
              title={project.title}
              category={project.category}
              description={project.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
